import { Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { CmxLayoutService } from '../../../services/cmx-layout.service';
import { LegalEntityService } from '../../../services/legal-entity.service';

@Component({
  selector: 'cmx-legal-entity',
  templateUrl: './cmx-legal-entity.component.html',
  styleUrls: ['./cmx-legal-entity.component.scss'],
})
export class CmxLegalEntityComponent implements OnInit, OnDestroy {
  public isRtl: boolean;
  public isMobile: boolean;
  public isCollapsed: boolean;
  public isLegalEntityListOpen: boolean;

  private subscriptions: Subscription[] = [];

  constructor(
    private layout: CmxLayoutService,
    public legalEntity: LegalEntityService,
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.layout.isLegalEntityListOpen.subscribe((value) => (this.isLegalEntityListOpen = value)),
      this.layout.isMobile.subscribe((value) => (this.isMobile = value)),
      this.layout.direction.subscribe((value) => (value === 'rtl' ? (this.isRtl = true) : (this.isRtl = false))),
      this.layout.isCollapsed.subscribe((value) => (this.isCollapsed = value)),
    );
  }

  toggleLegalEntityList() {
    if (this.isMobile) {
      this.layout.isMobileEntitySelectorOpen.next(true);
      this.layout.isMobileAppSelectorOpen.next(false);
      this.layout.isMobileLangSelectorOpen.next(false);
      this.layout.isMobileMenuOpen.next(false);
    } else {
      this.layout.isLegalEntityListOpen.next(!this.isLegalEntityListOpen);
    }
  }

  ngOnDestroy() {
    this.subscriptions.map((sub) => sub.unsubscribe());
  }
}
